import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SkeletonDocumentComponent } from "./skeleton-document.component";
import { SkeletonModule } from "primeng/skeleton";

@NgModule({
    imports: [
        CommonModule,
        SkeletonModule
    ],
    declarations: [
        SkeletonDocumentComponent
    ],
    exports: [
        SkeletonDocumentComponent
    ]
})
export class SkeletonDocumentModule { }